export const getFormattedUrlParams = <T extends object>(requestParams: T): string => {
  let params = '';
  for (const paramsKey of Object.keys(requestParams) as (keyof T)[]) {
    params += `${String(paramsKey)}=${(requestParams as any)[paramsKey]}&`;
  }
  params = params.slice(0, -1);
  return params;
}